import React from 'react';
import { Resizable } from 'react-resizable';
import './ResizableTitle.css';

/**
 * リサイズ可能なテーブルヘッダーセル（<th>）。
 * ------------------------------------------------------------------
 * antd `<Table>` の `components.header.cell` に差し込んで、列幅をマウス
 * ドラッグで調整できるようにするためのラッパー。react-resizable の
 * `<Resizable>` で `<th>` を包み、右端のハンドルでドラッグする。
 *
 * - `width` が無い列（アクション列など `resizable:false`）はそのまま素の
 *   `<th>` を返す（リサイズ非対象）。
 * - ハンドルの onClick は伝播を止める（ヘッダークリックのソートに連動させない）。
 * - `<th>` の props・className は保存するため、デザインシステムの
 *   `theme.components.Table`（cream ヘッダー等）はそのまま効く。
 *
 * 通常はページから直接使わず、`useResizableColumns` 経由で配線する。
 */
const ResizableTitle = (props) => {
  const { onResize, width, ...restProps } = props;

  // 幅指定・onResize が無い列はリサイズ非対象 → 素の <th>
  if (!width || !onResize) {
    return <th {...restProps} />;
  }

  return (
    <Resizable
      width={width}
      height={0}
      handle={
        <span
          className="react-resizable-handle"
          // ハンドル上のクリックがヘッダーのソートに伝播しないように
          onClick={(e) => e.stopPropagation()}
        />
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...restProps} />
    </Resizable>
  );
};

export default ResizableTitle;
